<template>
  <v-card>
    <v-card-text>
      <AsyncComponent
        :request-status="requestStatus"
        error-message="teavituste laadimine ebaõnnestus"
      >
        <table>
          <tr>
            <th>Klient</th>
            <th>Lõppema hakkab</th>
            <th>Lõppemise kuupäev</th>
          </tr>
          <tr v-for="(notification, index) in notifications" :key="index">
            <td>
              <a :href="getClientUrl(notification.clientId)">
                {{ notification.client.fullName }}
              </a>
            </td>
            <td>{{ notification.message }}</td>
            <td>{{ notification.expiringDate | date }}</td>
          </tr>
        </table>

        <p v-if="requestStatus.isSuccess && notifications.length === 0">
          Ükski teenus ega hinnang ei lähene hetkel lõpule.
        </p>
      </AsyncComponent>
    </v-card-text>
  </v-card>
</template>

<script>
import { routerUrls } from '@/router'
import ExpirationNotification from '@/dataAccess/dto/ExpirationNotification'
import AsyncComponent from '@/components/AsyncComponent'
import { ApiRequestStatus } from '@/dataAccess/ApiRequestStatus'

export default {
  components: { AsyncComponent },
  data() {
    return {
      requestStatus: ApiRequestStatus.ofLoading(),
      notifications: []
    }
  },
  async created() {
    ;[
      this.notifications,
      this.requestStatus
    ] = await ExpirationNotification.getAllFromApi()
  },
  methods: {
    getClientUrl(clientId) {
      return `#${routerUrls.clientPage}${clientId}`
    }
  }
}
</script>
<style scoped>
th,
td {
  padding-right: 15px;
}

.greeting {
  color: var(--v-primary-base);
  font-size: large;
  font-weight: bold;
}
</style>
